// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3GBL3","title":"Images45_title__1s2Gf","images":"Images45_images__3rIMv"};